
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invitation",
      function () {
        return require("private-next-pages/invitation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invitation"])
      });
    }
  